import { schemes, zSchema } from "@zeal/common";

export const postWorkerSummaryRequestSchema = zSchema.object({
  active_workers: zSchema.boolean(),
  companyID: schemes.companyID(),
  media_type: zSchema.string(),
  worker_type: zSchema.string(),
  custom_attributes: zSchema.record(zSchema.string(), zSchema.any()),
});

export type TPostWorkerSummaryRequestSchema = zSchema.infer<
  typeof postWorkerSummaryRequestSchema
>;
